<template>
  <div class="treeContainer">
    <Spin fix v-show="loading">机构加载中...</Spin>
    <Tree
      :data="orgTreeData"
      :load-data="loadData"
      :multiple="opts.multiple == undefined ? false: opts.multiple"
      :render="renderContent"
      :show-checkbox="opts.showCheckbox == undefined ? false: opts.showCheckbox"
      :size="opts.size || 'default'"
      @on-check-change="changeCheckNode"
      @on-select-change="changeSelectNode"
      class="selfTree"
      node-key="id"
      ref="orgTree"
    ></Tree>
    <!-- <Tree
      :data="orgTreeData"
      :multiple="opts.multiple == undefined ? false: opts.multiple"
      :render="renderContent"
      :show-checkbox="opts.showCheckbox == undefined ? false: opts.showCheckbox"
      @on-check-change="changeCheckNode"
      @on-select-change="changeSelectNode"
      class="selfTree"
      v-else
    ></Tree>-->
  </div>
</template>
<script>
export default {
  name: 'sunflowerOrgTree',
  props: {
    opts: {
      showAll: true
    }
  },
  data () {
    return {
      orgTreeData: [],
      loading: false,
      current: null
    }
  },
  computed: {
    isAdmin: function () {
      return this.$store.getters['userInfo/isAdmin'] || false
    }
  },
  methods: {
    refreshNode: function (id) {
      this.initTree(null)
      // let { updateKeyChildren, } = this.$refs.orgTree
      // let params = new this.$URLSearchParams()
      // params.append("showAll", this.opts.showAll == undefined ? true : this.opts.showAll)
      // params.append("calcDis", this.opts.calcDis == undefined ? false : this.opts.calcDis)
      // if (id) params.append("parentId", id)
      // this.current = { name: 'xasds', nodeKey: id }
      // this.$axios.post(this.$apis.organizationManager.organization.getOrgTreeAsyn, params).then(res => {
      //   if (res.success) {
      //     let item = res.result || []
      //     this.current.children = item
      //   } else {
      //     this.$Message.error(res.message)
      //   }
      // })
    },
    changeSelectNode: function (checked, current) {
      console.log('current', current)
      this.current = current
      this.$emit('changeSelectNode', { checked: checked.length > 0, node: current })
    },
    changeCheckNode: function (checked) {
      this.$emit('changeCheckNode', { checked: checked })
    },
    renderContent (h, { root, node, data }) {
      if (data.id == null) {
        return h('span', {
          style: {
            display: 'inline-block',
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between'
          }
        }, [
          h('span', {
            style: {
              // overflow: 'hidden',
              // textOverflow: 'ellipsis'
            }
          }, [
            h('Icon', {
              props: {
                type: 'ios-home'
              },
              style: {
                marginRight: '8px',
                fontSize: '1.2rem'
                // overflow: 'hidden',
                // textOverflow: 'ellipsis'
              }
            }),
            h('span', data.name)
          ]),
          // h('span', {
          //   style: {
          //     display: 'inline-block',
          //     float: 'right',
          //     marginRight: '1.2rem'
          //   }
          // }
          // )
        ])
      } else {
        return h('span', {
          style: {
            display: 'inline-block',
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between'
          }
        }, [
          h('span', {
            style: {
              color: data.disabled ? '#999' : ''
            }
          }, [
            // h('Icon', {
            //   props: {
            //     type: 'ios-people'
            //   },
            //   style: {
            //     marginRight: '8px',
            //     fontSize: '1.2rem'
            //     // overflow: 'hidden',
            //     // textOverflow: 'ellipsis'
            //   }
            // }),
            h('span', {
              attribute: {
                title: data.name
              },
            }, data.disabled ? `${data.name}` : this.opts.showSimple == true ? `${data.name}` : (data.category == 'establishment' ? `【${data.childrenNum ? data.childrenNum : 0}】${data.name}（共${data.commissionNum || 0}调委会）` : `${data.name}`))
          ])
        ])
      }
    },
    loadData: function (item, callback) {
      this.initTree(item.id, callback)
    },
    initTree: function (id, callback) {
      let that = this
      this.loading = true
      let params = new this.$URLSearchParams()
      params.append("showAll", this.opts.showAll == undefined ? true : this.opts.showAll)
      params.append("calcDis", this.opts.calcDis == undefined ? false : this.opts.calcDis)

      // if (this.isAdmin) {
      if (id) params.append("parentId", id)
      this.$axios.post(this.$apis.organizationManager.organization.getOrgTreeAsyn, params).then(res => {
        if (res.success) {
          let item = res.result || []
          if (callback) {
            callback(item)
          } else {
            if (this.opts.showNextLevel != false || item.length == 1) {
              let all = []
              item.forEach(element => {
                all.push(this.handleChildren(element, 1))
              })
              Promise.all(all).then(res => {
                console.log('Promise all res', res)
              }).finally(() => {
                that.initItem(item)
              })
            } else {
              this.initItem(item)
            }
          }
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('机构树获取失败！')
      }).finally(val => {
        that.loading = false
      })
    },
    initItem: function (item) {
      if (this.opts.showTop) {
        this.orgTreeData = [{
          name: '机构树',
          expand: true,
          type: 'org',
          disabled: true,
          code: '',
          children: item
        }]
      } else {
        this.orgTreeData = item
      }
    },
    handleChildren (element, level) {
      element.expand = true
      let that = this
      var p1 = new Promise((resolve, reject) => {
        let paramsC = new this.$URLSearchParams()
        paramsC.append("showAll", this.opts.showAll == undefined ? true : this.opts.showAll)
        paramsC.append("calcDis", this.opts.calcDis == undefined ? false : this.opts.calcDis)
        paramsC.append("parentId", element.id)
        this.$axios.post(this.$apis.organizationManager.organization.getOrgTreeAsyn, paramsC).then(res => {
          if (res.success) {
            that.$set(element, 'children', res.result || [])
            let max = this.isAdmin ? 1 : 2
            if (level < max) {
              level++
              let all = []
              element.children.forEach(child => {
                all.push(this.handleChildren(child, level))
              })
              Promise.all(all).then(resC => {
                resolve(resC.result || [])
              })
            } else {
              resolve(res.result || [])
            }
          }
        })
      })
      return p1
    }
  },
  beforeMount () {
    this.initTree(null)
  }
}
</script>
<style scoped>
.treeContainer {
  overflow: auto;
}
.selfTree {
  width: fit-content;
}
</style>